import { useQuery } from '@tanstack/react-query';
import { getExistingOneOnOneListApi } from 'screens/oneOnOneRabbit/InstancePage/apis';
import { oneOneOneReactQueryKeys } from 'screens/oneOnOneRabbit/InstancePage/constants/oneOnOneReactQueryKeys';

export const useExistingOneOnOneList = () =>
  useQuery([oneOneOneReactQueryKeys.existingOneonOneList], () => getExistingOneOnOneListApi(), {
    enabled: true,
  });
